export default __webpack_public_path__ + "static/media/elevate-dmb-1.7cd2ed3c.png";